import axios from "./axios";

// Función para realizar una solicitud POST al endpoint de reservas
export const getReserves = (body) => axios.post("/getAvailability", body);

export const createReservationHB = (reservationData) =>
  axios.post("/create-reservehb", reservationData);
